import { ApolloError, ServerError } from "@apollo/client";
import { useAuthorization } from "hooks/useAuthorization";
import { useCurrentUser } from "hooks/useCurrentUser";
import { useFeatureFlags } from "hooks/useFeatureFlags";
import { PropsWithChildren, useEffect } from "react";
import { Outlet, useNavigate } from "react-router";
import { useCustomerNavSectionsV2 } from "routes/Customer/customerNavSectionsV2";
import { ScoutSidebarFooterTrigger } from "routes/Customer/Scout/PopoverScout";
import { hasScoutAccess } from "routes/Customer/Scout/scoutAccess";

import { LayoutV2 } from "./LeftNavV2/LayoutV2";

function useHandleForbiddenTenant(error: ApolloError | undefined) {
  const navigate = useNavigate();

  useEffect(() => {
    // If the user is not authorized for this tenant, redirect to the home page.
    // This has the effect of auto switching to an authorized tenant.
    if (error && error.networkError && (error.networkError as ServerError).statusCode === 403) {
      navigate("/", { replace: true });
    }
  }, [error, navigate]);
}

export function Layout(props: PropsWithChildren) {
  const { featureFlags } = useFeatureFlags();
  const { hasPermissions } = useAuthorization();
  const { isStaff, isEmulating } = useCurrentUser();
  const { error, navItems: customerNavSectionsV2 } = useCustomerNavSectionsV2();
  const scoutEnabled = hasScoutAccess({
    flags: featureFlags,
    hasPermissions,
    isStaff: isStaff && !isEmulating,
  });

  useHandleForbiddenTenant(error);

  return (
    <>
      <LayoutV2 navSections={customerNavSectionsV2}>
        {props.children}
        <Outlet />
      </LayoutV2>
      {scoutEnabled ? <ScoutSidebarFooterTrigger /> : null}
    </>
  );
}
